
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 */
import {Component, Prop, Vue} from "vue-property-decorator";
import LessonsData from "@/components/lessonsData/lessons-data.vue";
import {MessageBase} from "@/ts/Announcement";
import { MobileModule } from '../../store/modules/mobile';
import Chat from "@/components/messageInteraction/chat.vue";
import Menu from "@/ts/Menu";


@Component({
  components: {Chat, LessonsData}
})
export default class ClassroomOther extends Vue {

  @Prop() activityMessageBase: MessageBase;
  @Prop() subscriptionList: any;
  @Prop({
    type: Array,
    default: () => {
      return []
    },
    required: true
  }) materials: [];

  @Prop({default: false})
  isSend: boolean;
  menuList = [
    new Menu(2, "留言互动", null, 0),
    new Menu(1, "在线学生", 0, 0),
    new Menu(3, "课堂资料"),
  ];
  $refs: {
    online?: HTMLFormElement | null
    message?: HTMLFormElement | null
  }


  mounted(): void {
    this.activeClick(2);
  }

  destroyed(): void {
    MobileModule.setOnlineUser(false)
  }

  activeClick(val) {
    MobileModule.setOnlineUser(val === 1)
    this.menuList.forEach(e => {
      if (e.key === val) {
        e.setActive(true)
      } else {
        e.setActive(false);
      }
    })
    switch (val) {
      case 1:
        break;
      case 2:
        this.$refs.message.init();
        break;
    }
  }

  userOnline(data) {
    this.$refs.online.userOnline(data)
  }

  userOffline(data) {
    this.$refs.online.userOffline(data)
  }

  userPublishChange(data) {
    this.$refs.online.userPublishChange(data);
  }

  processMessage(data) {
    this.$refs.message.processMessage(data);
  }

  pushNotice() {
    this.$refs.message.pushNotice();
  }

  getShow(val: number): boolean {
    // return this.menuList.find(e => e.key = val).getActive()
    return this.menuList[val].getActive()
  }

  userTotalCountChange(num: number) {
    this.menuList[1].total = num;
  }

  /**
   * 学生上线数量改变
   */
  userOnlineCountChange(num: number) {
    this.menuList[1].current = num;
  }

  /**
   * 信息个数发生变化
   * @param num
   */
  messageCountChange(num: number) {
    this.menuList[0].total = num;
  }
}
